import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { useState } from "react";
import { Card, Grid } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useCustomerValue } from "providers/CustomerContext";
import { getPutawayCancelReport,getCustOrdNbrOption } from "services/data.report.service";
import { InboundLayout } from "ui-components/Layout";
import { LoadingDialog } from "ui-components/Alert";
import { SelectFields } from "ui-components/Form";
import { downloadPDF2, downloadFile } from "layouts/views/common/file"; 
import { Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";

function PutawayCancelReport() {
  const {permissions, allowAll} = useTeamValue()
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ content="Invalid Request" onChange={setAlert} />);
  const exportPermission = allowAll || (Boolean(permissions["Putaway Cancel Report_Report"]) && permissions["Putaway Cancel Report_Report"].findIndex(b => b==="export") !== -1);

  const downloadReportMutation = useMutation(getPutawayCancelReport, {
    onSuccess: (response) => {
      if (reportType === "PDF") {
        downloadPDF2(response.data,`${custOrdNbr}.pdf`);
      } else {
        downloadFile(response.data, `${custOrdNbr}.csv`);
      }
    },
    onError,
  });

  const [custOrdNbrOptions, setCustOrdNbrOptions] = useState([]);
  const [custOrdNbr, setCustOrdNbr] = useState(null);
  const [reportType, setReportType] = useState("PDF");

  const handleSubmit = () => {
    setAlert(null);
    downloadReportMutation.mutate({
      customerCode,
      custOrdNbr,
      reportType,
      reportName: "PutawayCancel",
    });
  };

  useQuery({
    queryKey: ["report-putaway", { customerCode }],
    queryFn: () => getCustOrdNbrOption({ customerCode }),
    enabled:Boolean(customerCode),
    onSuccess: (data) => {
      setCustOrdNbr(null);
      setCustOrdNbrOptions(data.data.data);
    },
  });

  const downloadStatus = downloadReportMutation.status === "loading";

  return (
    <InboundLayout>
      {downloadStatus && <LoadingDialog />}

      <Card sx={{ height: "100%" }}>
        <MDBox p={3}>
          {alert}
          <MDBox pb={3}>
            <MDTypography color="info" variant="h3">
              Export Putaway Cancel Report
            </MDTypography>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "custOrdNbr",
                  label: "Customer Order Number",
                  value: custOrdNbr,
                  errors: {},
                  required: true,
                }}
                options={custOrdNbrOptions}
                onChange={(e, v) => setCustOrdNbr(v)}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "reportType",
                  label: "Export to File Type *",
                  value: reportType,
                  errors: {},
                  required: true,
                }}
                options={["PDF", "CSV"]}
                onChange={(e, v) => setReportType(v)}
              />
            </Grid>
          </Grid>

          <MDBox mt={2} display="flex" justifyContent="center">
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              disabled={!Boolean(custOrdNbr) || !exportPermission}
              onClick={handleSubmit}
            >
              Download
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </InboundLayout>
  );
}

export default PutawayCancelReport;
